/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SMTPConfigurationUpdate
 */
export interface SMTPConfigurationUpdate {
    /**
     * 
     * @type {string}
     * @memberof SMTPConfigurationUpdate
     */
    fromAddress: string;
    /**
     * 
     * @type {string}
     * @memberof SMTPConfigurationUpdate
     */
    server: string;
    /**
     * 
     * @type {number}
     * @memberof SMTPConfigurationUpdate
     */
    port: number;
    /**
     * 
     * @type {string}
     * @memberof SMTPConfigurationUpdate
     */
    tls: string;
    /**
     * 
     * @type {string}
     * @memberof SMTPConfigurationUpdate
     */
    username: string | null;
    /**
     * 
     * @type {string}
     * @memberof SMTPConfigurationUpdate
     */
    password: string | null;
}

export function SMTPConfigurationUpdateFromJSON(json: any): SMTPConfigurationUpdate {
    return SMTPConfigurationUpdateFromJSONTyped(json, false);
}

export function SMTPConfigurationUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMTPConfigurationUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromAddress': json['from_address'],
        'server': json['server'],
        'port': json['port'],
        'tls': json['tls'],
        'username': json['username'],
        'password': json['password'],
    };
}

export function SMTPConfigurationUpdateToJSON(value?: SMTPConfigurationUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from_address': value.fromAddress,
        'server': value.server,
        'port': value.port,
        'tls': value.tls,
        'username': value.username,
        'password': value.password,
    };
}


